import React from 'react';
import { Link, Callout, Text } from '@scale/scaleui-radix';
import { faBookOpen } from '@fortawesome/pro-solid-svg-icons';
import { CompassInstructions } from '@scale/compass-ui/components/CardInstructions';
import { ColumnSubType } from '@scale/compass-shared/types';
import { SERVICE_ACCOUNT } from '@scale/compass-shared/GoogleSheets';

export const CdsUploadInstructions: React.FC = () => {
  return (
    <div className="mb-3">
      <CompassInstructions
        header="How to use the CDS Upload card"
        storageKey="cdsUploadInstructionsExpanded"
        icon={faBookOpen}
      >
        <Callout.Text>
          <Text as="p">
            This card will upload files to CDS from provided Google Drive URLs or direct image URLs.
            Here's how it works:
          </Text>
          <Text className="list-disc ml-6 mt-2">
            <li>Column headers will be used as the property names</li>
            <li>
              Required column:{' '}
              <code className="px-2 py-1 bg-blue-100 rounded text-blue-700">Task ID</code> (can be
              automatically detected if the column has subtype {ColumnSubType.TASK_ID})
            </li>
            <li>
              Required URL column (must include exactly one):{' '}
              <code className="px-2 py-1 bg-blue-100 rounded text-blue-700">Google Drive URL</code>{' '}
              or <code className="px-2 py-1 bg-blue-100 rounded text-blue-700">IMAGE URL</code>
            </li>
            <li>
              Optional column:{' '}
              <code className="px-2 py-1 bg-blue-100 rounded text-blue-700">File name suffix</code>{' '}
              - Optional suffix for file names. Examples: • With suffix "a": task123_a.jpg • With
              suffix "b": task123_b.jpg • Without suffix: task123.jpg
            </li>
            <li>
              Optional column:{' '}
              <code className="px-2 py-1 bg-blue-100 rounded text-blue-700">Item Type</code> -
              Specifies the type of item being uploaded (defaults to "Response" if not provided)
            </li>
          </Text>
          <Text as="p" className="mt-2">
            You can leave the Side column blank if you don't need to specify a side for your files.
          </Text>
          <Text as="p" className="mt-2">
            <strong>Important:</strong> If using Google Drive URLs, you must share your Google Drive
            files/folders with:{' '}
            <code className="px-2 py-1 bg-blue-100 rounded text-blue-700">{SERVICE_ACCOUNT}</code>
          </Text>
          <Text as="p" className="mt-2">
            Here is the{' '}
            <Link
              href="https://docs.google.com/spreadsheets/d/1XEQ_RlUmjRbe_AuYYxQIWfGJF2rEXzAQtuLbx1B0V0M/edit?gid=1324941182#gid=1324941182"
              target="_blank"
              rel="noopener noreferrer"
              size="2"
              className="px-2 py-1 bg-blue-100 rounded text-blue-700 hover:bg-blue-200"
            >
              Template Google Sheet
            </Link>{' '}
            you could use for pulling in the data.
          </Text>
        </Callout.Text>
      </CompassInstructions>
    </div>
  );
};
